import React, { useEffect, useState } from "react";
import DashboardContainer from "../../components/dashboard-container";
import { Box, CircularProgress } from "@mui/material";
import { roleService } from "../../utils/services/role.service";
import CustomPagination from "../../components/pagination";
import RolesList from "../../components/role-list";
import RoleModal from "../../components/role-modal";

const Roles = () => {
  const [selectedRole, setSelectedRole] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [roleList, setRoleList] = useState([]);
  const [viewMode, setViewMode] = useState("list");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);
  const [dataCount, setDataCount] = useState(rowsPerPage);
  const [loading, setLoading] = useState(false);
  const clientId = localStorage.getItem("client_id");
  const [selectedClient, setSelectedClient] = useState({});

  const fetchRoles = async () => {
    setLoading(true);
    try {
      const response = await roleService.fetch(rowsPerPage, page * rowsPerPage);
      setRoleList(response.data);
      setLoading(false);
      setDataCount(response?.total);
    } catch (error) {
      console.error("Fetch failed:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchRoles();
  }, [page, rowsPerPage]);

  return (
    <>
      <DashboardContainer
        filterButton={false}
        hideUploadButton
        header={"Roles"}
        title={"+ Role"}
        onClickAddButton={() => setOpenModal(true)}
        setViewMode={setViewMode}
        hideFilterClient={true}
        onClickRefresh={() => fetchRoles()}
      >
        <RoleModal
          selectedRole={selectedRole}
          handleClose={() => {
            setOpenModal(false);
            setSelectedRole(null);
          }}
          open={openModal}
          onAddData={fetchRoles}
        />
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 9999,
              color: "white",
            }}
          >
            <CircularProgress color="inherit" />
          </Box>
        ) : (
          <RolesList
            dataCount={dataCount}
            currentPage={page}
            itemsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            setPage={setPage}
            onDeleteData={fetchRoles}
            onEditData={(e) => {
              setSelectedRole(e);
              setOpenModal(true);
            }}
            data={roleList}
            viewMode={viewMode}
            selectedRole={selectedRole}
            setSelectedRole={setSelectedRole}
            onDeleteRole={() => {
              setRoleList(
                roleList.filter((role) => role._id !== selectedRole._id)
              );
              setSelectedRole(null);
            }}
            onEditRole={(role) => {
              setSelectedRole(role);
              setOpenModal(true);
            }}
          />
        )}
        <CustomPagination
          page={page}
          rowsPerPage={rowsPerPage}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
          dataCount={dataCount}
          disableNext={dataCount <= rowsPerPage * (page + 1)}
        />
      </DashboardContainer>
    </>
  );
};

export default Roles;
